const DeviceIdStorageKey = "AuthorizationTrustedDeviceId";
const TrustedTokenStorageKey = "AuthorizationTrustedDeviceTokens";

let MemoryDeviceId = "";
let MemoryTrustedTokens = {};

/**
 * Web可信设备信息。
 * 设备ID长期保存，用于标识当前浏览器。
 * @param {string} clientId IdentityServer客户端ID
 */
let TrustedDevice = function (clientId) {
  this.ClientId = clientId || "";
  this.DeviceId = GetOrCreateDeviceId();
};

/**
 * 生成鉴权中心要求的可信设备请求头。
 * @param {string} account 当前登录手机号
 */
TrustedDevice.prototype.Headers = function (account) {
  var headers = {
    "X-Client-Type": "Web",
    "X-Device-Id": this.DeviceId
  };
  var trustedToken = GetTrustedToken(this.ClientId, account);
  if (trustedToken) {
    headers["X-Trusted-Device-Token"] = trustedToken;
  }
  return headers;
};

/**
 * 保存短信登录成功后返回的可信设备令牌。
 * 不同手机号分别保存，避免同一浏览器切换账号时相互覆盖。
 */
TrustedDevice.prototype.SaveToken = function (account, trustedToken) {
  if (!account || !trustedToken) {
    return;
  }

  var tokens = ReadTrustedTokens();
  tokens[BuildTokenKey(this.ClientId, account)] = trustedToken;
  MemoryTrustedTokens = tokens;
  try {
    window.localStorage.setItem(TrustedTokenStorageKey, JSON.stringify(tokens));
  } catch (e) {
    // 浏览器禁用本地存储时，本次页面生命周期内仍可继续使用。
  }
};

function GetOrCreateDeviceId() {
  if (MemoryDeviceId) {
    return MemoryDeviceId;
  }

  try {
    MemoryDeviceId = window.localStorage.getItem(DeviceIdStorageKey) || "";
  } catch (e) {
    MemoryDeviceId = "";
  }
  if (!MemoryDeviceId) {
    MemoryDeviceId = CreateDeviceId();
    try {
      window.localStorage.setItem(DeviceIdStorageKey, MemoryDeviceId);
    } catch (e) {
      // 浏览器禁用本地存储时，使用内存中的设备ID。
    }
  }
  return MemoryDeviceId;
}

function CreateDeviceId() {
  var cryptoApi = window.crypto || window.msCrypto;
  if (cryptoApi && typeof cryptoApi.randomUUID === "function") {
    return cryptoApi.randomUUID();
  }

  if (cryptoApi && typeof cryptoApi.getRandomValues === "function") {
    var bytes = new Uint8Array(16);
    cryptoApi.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    var hex = Array.prototype.map.call(bytes, function (value) {
      return value.toString(16).padStart(2, "0");
    }).join("");
    return [
      hex.slice(0, 8),
      hex.slice(8, 12),
      hex.slice(12, 16),
      hex.slice(16, 20),
      hex.slice(20)
    ].join("-");
  }

  return Date.now().toString(36) + "-" + Math.random().toString(36).slice(2);
}

function ReadTrustedTokens() {
  try {
    var value = window.localStorage.getItem(TrustedTokenStorageKey);
    if (value) {
      return JSON.parse(value) || {};
    }
  } catch (e) {
    // 存储内容异常或本地存储不可用时退回内存数据。
  }
  return MemoryTrustedTokens;
}

function GetTrustedToken(clientId, account) {
  if (!account) {
    return "";
  }
  var tokens = ReadTrustedTokens();
  return tokens[BuildTokenKey(clientId, account)] || "";
}

function BuildTokenKey(clientId, account) {
  return encodeURIComponent(clientId || "") + "|" +
    encodeURIComponent(String(account).trim());
}

export { TrustedDevice };
